// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
import cuckoo from "../cuckoo/cuckoo"
import { cuckooEvents } from "../../consts/enums"
import type { DocumentNeedInput } from "../../types/booking"

export type DocumentNeed = "never" | "check-in" | "booking"

export default function (input: DocumentNeedInput): DocumentNeed {
  switch (input) {
    case 0:
      return "never"
    case 1:
      return "check-in"
    case 2:
      return "booking"
    default:
      cuckoo.track(cuckooEvents.INTERNAL_MAPPER_DOCUMENT_NEED_UNSUPPORTED, { input })

      return "booking" // Safe default
  }
}
